const ITEMS = [
  "Build Strength",
  "Trust Your Body",
  "The Science",
  "The Psychology",
  "Train With Confidence",
  "Food Freedom",
  "Autonomy",
  "Community",
];

const Marquee = ({ dark = true }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y py-5 md:py-7 ${
        dark ? "border-white/10 bg-ink text-white" : "border-ink/10 bg-mist text-ink"
      }`}
    >
      <div className="animate-marquee-slow flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-2xl md:text-4xl italic font-light px-6 md:px-10">
                  {item}
                </span>
                <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-ocean" : "bg-ocean"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
